
import { arc, pie } from "d3-shape";
import { select } from "d3-selection";
import { scaleOrdinal } from "d3-scale";
import { Vue } from "vue-class-component";
import { Ref, Prop } from "vue-property-decorator";

type colorCondtions = {
  name: string;
  color: string[];
}[];
const colorCondtions: colorCondtions = [
  {
    name: "personality",
    color: ["#FDE96E", "#AA45F8", "#77C6C3", "#FC8988", "#62B1FB"]
  },
  { name: "rd", color: ["#FC8988", "#62B1FB", "#77C6C3", "#FDE96E"] },
  { name: "pm", color: ["#FC8988", "#77C6C3", "#FDE96E", "#62B1FB"] }
];
export default class AnalyticsPieChart extends Vue {
  @Prop({ type: String, required: true }) readonly chartType: "personality" | "rd" | "pm" = "personality";
  @Prop({ type: Array, required: true }) readonly chartData!: {
    name: string;
    value: number;
  }[];
  @Ref("container") readonly container!: HTMLElement;
  draw() {
    const width = 300;
    const height = width;
    const margin = 20;
    const radius = Math.min(width, height) / 2 - margin;

    const Color = colorCondtions.find(chart => {
      if (chart.name === this.chartType) return chart;
    });

    select(this.container)
      .select("svg")
      .remove();
    const svg = select(this.container)
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

    const color = scaleOrdinal()
      .domain(this.chartData.map(c => c.name))
      .range(Color!.color);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const piec = pie<any>()
      .value(d => d.value)
      // @ts-ignore
      .sort(null);
    const dataReady = piec(this.chartData.map(c => ({ key: c.name, value: c.value })));
    svg
      .selectAll("whatever")
      .data(dataReady)
      .enter()
      .append("path")
      .attr(
        "d",
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        arc<any>()
          .innerRadius(radius - 20)
          .outerRadius(radius)
      )
      // @ts-ignore
      .attr("fill", d => {
        return color(d.data.key);
      });
    const legend = svg
      .append("g")
      .attr("class", "legend")
      .attr("height", 200)
      .attr("width", 200)
      .attr("transform", `translate(-50, -35)`);

    // Create colour squares
    legend
      .selectAll("rect")
      .data(this.chartData.map(c => c.name))
      .enter()
      .append("rect")
      .attr("x", -10)
      .attr("y", (_d, i) => {
        return i * 20;
      })
      .attr("width", 10)
      .attr("height", 10)
      .style("fill", function(d, i) {
        return Color!.color[i];
      });

    // Create text next to squares
    legend
      .selectAll("text")
      .data(this.chartData.map(c => `${c.name} (${c.value.toFixed(1)} %)`))
      .enter()
      .append("text")
      .attr("font-size", 12)
      .attr("x", 10)
      .attr("y", function(d, i) {
        return i * 20 + 11;
      })
      .attr("fill", "#737373")
      .text(function(d) {
        return d;
      });
  }
  updated() {
    this.draw();
  }
  mounted() {
    this.draw();
  }
}
